import React, { useState } from "react";
import { Typography } from "@mui/material";
import { TextField, Button } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import { Request_Get_School_Events_Fuzzy_Search } from "../../api/Request_Get_School_Events_Fuzzy_Search";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function SearchBar({ setEvents }) {
  const { logout } = StaffuseAuth();

  //Table Search
  const [searchName, setSearchName] = useState("");
  const [searchPD, setSearchPD] = useState(localStorage.getItem("Username"));
  const handleSearchName = (event) => {
    setSearchName(event.target.value);
  };

  const handleSearchPD = (event) => {
    setSearchPD(event.target.value);
  };
  function handleSubmit(e) {
    e.preventDefault();
    Request_Get_School_Events_Fuzzy_Search(
      "Schools",
      "Events",
      searchName,
      searchPD,
      1000,
      setEvents,
      logout
    );
  }

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "25%",
        maxHeight: "150px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Search Bar
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Change to row to align items in a line
          flexWrap: "wrap",
          alignItems: "center", // Align items vertically
          gap: "5px",
          color: "black",
          padding: "5px",
        }}
      >
        <TextField
          id="search_name"
          label="Search by Name"
          variant="outlined"
          value={searchName}
          onChange={handleSearchName}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />

        <TextField
          id="search_PD"
          label="Search PD"
          variant="outlined"
          value={searchPD}
          onChange={handleSearchPD}
          size="small" // Makes the TextField smaller
          sx={{ backgroundColor: "white", flex: 1, fontSize: "0.875rem" }} // Adjust flex to control width, and optionally adjust fontSize
        />
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ flex: "none" }}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Search
        </Button>
      </Box>
    </Box>
  );
}

export default SearchBar;
